import styled from 'styled-components';
import {LoadingState} from './LoadingState';
import {
  SkeletonChat,
  SkeletonDetails,
  SkeletonForm,
  SkeletonGrid,
  SkeletonList,
  SkeletonTable,
} from './Skeleton';

const SpinnerWrapper = styled.div`
  width: 100%;
  margin: auto;
  margin-top: 24px;
`;

type SpinnerVariantT =
  | 'spinner'
  | 'list'
  | 'grid'
  | 'details'
  | 'form'
  | 'table'
  | 'chat';

interface SpinnerWrappedProps {
  variant?: SpinnerVariantT;
  title?: string;
  description?: string;
  count?: number;
}

export const SpinnerWrapped = ({
  variant = 'spinner',
  title,
  description,
  count = 5,
}: SpinnerWrappedProps) => {
  if (variant === 'spinner') {
    return (
      <SpinnerWrapper>
        <LoadingState title={title} description={description} />
      </SpinnerWrapper>
    );
  }

  const skeletons: Record<Exclude<SpinnerVariantT, 'spinner'>, JSX.Element> = {
    list: <SkeletonList count={count} />,
    grid: <SkeletonGrid count={count} />,
    details: <SkeletonDetails panels={count} />,
    form: <SkeletonForm fields={count} />,
    table: <SkeletonTable rows={count} />,
    chat: <SkeletonChat count={count} />,
  };

  return <SpinnerWrapper>{skeletons[variant]}</SpinnerWrapper>;
};
